var _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _circle, _ellipse5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrugIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33594 3.33333C3.33594 2.59695 3.93289 2 4.66927 2H11.3359C12.0723 2 12.6693 2.59695 12.6693 3.33333V12.6667C12.6693 13.4031 12.0723 14 11.3359 14H4.66927C3.93289 14 3.33594 13.4031 3.33594 12.6667V3.33333Z",
    stroke: "#00CCBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00521 4.66406V11.3307",
    stroke: "#00CCBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.0026,
    cy: 4.66667,
    rx: 0.666667,
    ry: 0.666667,
    fill: "#00CCBB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0026,
    cy: 4.66667,
    rx: 0.666667,
    ry: 0.666667,
    fill: "#00CCBB"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.0026,
    cy: 8.0026,
    rx: 0.666667,
    ry: 0.666667,
    fill: "#00CCBB"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0026,
    cy: 8.0026,
    rx: 0.666667,
    ry: 0.666667,
    fill: "#00CCBB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.0026,
    cy: 11.3307,
    r: 0.666667,
    fill: "#00CCBB"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0026,
    cy: 11.3307,
    rx: 0.666667,
    ry: 0.666667,
    fill: "#00CCBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrugIcon);
export default __webpack_public_path__ + "static/media/drug-icon.0cef754217ecb276a68ede0d8a7424af.svg";
export { ForwardRef as ReactComponent };